// Generated by CoffeeScript 1.6.3
(function() {
  rjm.util.categoryValues = (function() {
    var formatDataObjectForTemplateBySid, formatDataObjectForTemplateBySidAndValue, publicVars, rowCountCacheBySidAndValue, tooManyValuesBySid, valueCacheBySid;
    rowCountCacheBySidAndValue = {};
    valueCacheBySid = {};
    tooManyValuesBySid = {};
    formatDataObjectForTemplateBySidAndValue = function(sid, value) {
      var rowCount;
      rowCount = rowCountCacheBySidAndValue[sid][value];
      if (!_(rowCount).isUndefined() && !_(rowCount).isNull()) {
        return {
          id: value,
          text: value + " (" + rowCount + " rows)"
        };
      } else {
        return {
          id: value,
          text: value
        };
      }
    };
    formatDataObjectForTemplateBySid = function(sid) {
      var newData;
      newData = [];
      _(valueCacheBySid[sid]).each(function(value) {
        return newData.push(formatDataObjectForTemplateBySidAndValue(sid, value));
      });
      return newData;
    };
    publicVars = {
      formatDataObjectForTemplateBySidAndValue: formatDataObjectForTemplateBySidAndValue,
      getCategoryDataForSid: function(sid, clientId) {
        var defer, obj;
        defer = $.Deferred();
        obj = {};
        if (!valueCacheBySid.hasOwnProperty(sid)) {
          $.ajax({
            type: "GET",
            url: $.url("/chartBuilder/" + clientId + "/categoryvalues"),
            data: {
              id: sid
            }
          }).done(function(data) {
            rowCountCacheBySidAndValue[sid] = {};
            valueCacheBySid[sid] = [];
            tooManyValuesBySid[sid] = data.tooManyResults;
            _(data.categoryValues).each(function(rowCount, string) {
              rowCountCacheBySidAndValue[sid][string] = rowCount;
              return valueCacheBySid[sid].push(string);
            });
            obj.categoryValues = formatDataObjectForTemplateBySid(sid);
            obj.tooManyValues = tooManyValuesBySid[sid];
            return defer.resolve(obj);
          });
        } else {
          obj.categoryValues = formatDataObjectForTemplateBySid(sid);
          obj.tooManyValues = tooManyValuesBySid[sid];
          defer.resolve(obj);
        }
        return defer.promise();
      },
      select2QueryFunction: function(sid, apiConnId, trid, start, end, clientId) {
        var request, requestSequence, timeout;
        timeout = null;
        request = null;
        requestSequence = 0;
        return function(query) {
          if (query.term !== "" && query.context === null) {
            query.callback({
              results: [
                {
                  id: query.term,
                  text: query.term
                }
              ],
              more: true,
              context: query.term
            });
            if (request != null) {
              request.abort();
            }
            if (timeout != null) {
              window.clearTimeout(timeout);
            }
            return timeout = window.setTimeout(function() {
              var requestNumber;
              requestSequence += 1;
              requestNumber = requestSequence;
              return request = $.ajax({
                url: $.url("/chartBuilder/" + clientId + "/categoryvalues"),
                dataType: 'json',
                type: "GET",
                data: {
                  q: query.term,
                  id: sid,
                  apiConnId: apiConnId,
                  trid: trid,
                  start: start,
                  end: end
                }
              }).done(function(data) {
                var values;
                if (requestNumber < requestSequence) {
                  return;
                }
                values = [];
                _(data.categoryValues).each(function(rowCount, value) {
                  return values.push({
                    id: value,
                    text: rowCount === -1 ? value : value + " (" + rowCount + " rows)"
                  });
                });
                return query.callback({
                  results: values
                });
              });
            }, 100);
          } else if (query.context === null) {
            return query.callback({
              results: []
            });
          }
        };
      }
    };
    return publicVars;
  })();

}).call(this);
